import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
} from '@everlywell/ui-kit';
import DynamicIcon from 'components/DynamicIcon';
import StickyFooter from 'components/StickyFooter';
import { usePrePurchaseQuizContext } from 'contexts/PrePurchaseQuiz/PrePurchaseQuizContext';
import React from 'react';

import { BMI_VALUES } from '../../PrePurchaseQuizModalSteps/PrePurchaseQuizModalSteps';

export type BmiResultProps = {
  bmi: number;
};

const BmiResult = ({ bmi }: BmiResultProps) => {
  const { nextStep } = usePrePurchaseQuizContext();

  return (
    <Box>
      <Flex justifyContent="space-between" marginBottom="8">
        <Heading size="3xl" color="eggplant.light">
          BMI
        </Heading>
        <Heading size="3xl" color="eggplant.base">
          {bmi}
        </Heading>
      </Flex>

      <Flex marginBottom="3">
        <DynamicIcon
          icon="CaretCircleUp"
          color="eggplant.light"
          weight="fill"
          marginRight="1"
        />

        <Text color="tints.darkGrey">
          {bmi > BMI_VALUES.OVERWEIGHT
            ? 'Above healthy weight'
            : 'Slightly above healthy weight'}
        </Text>
      </Flex>

      <Heading size="2xl" marginBottom="8" color="tints.black">
        Losing{' '}
        <Text
          color="eggplant.light"
          fontSize="inherit"
          fontWeight="inherit"
          as="span"
        >
          just 5%
        </Text>{' '}
        of your body weight can seriously reduce the chance of heart disease.
      </Heading>

      <StickyFooter type="fixed">
        <Container
          size={['sm', 'sm', 'fluid']}
          paddingTop="6"
          paddingBottom={[6, null, 0]}
        >
          <Button
            onClick={() => nextStep()}
            width={['100%', null, 'fit-content']}
          >
            Next
          </Button>
        </Container>
      </StickyFooter>
    </Box>
  );
};

export default BmiResult;
